/*
 * @Date: 2023-04-09 18:26:07
 * @LastEditors: simLarry
 * @LastEditTime: 2023-05-03 19:32:25
 * @FilePath: \J1-M3-QRP-CODE\pages\restrict.js
 */
import React from "react";
import { Button } from 'antd';
import Header from '@/QRPComponent/header'; // 头部 组件
import { fetchRequest } from '$CONFIG/Fatch.config';
import { Apiversion } from '../config/Fatch.config';
import { ApiPort } from '$ACTIONS/API';

export default class Restrict extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            mainSiteUrl : '',
        }
        this.openLiveChat = this.openLiveChat.bind(this);
        this.addAffiliateParamToUrl = this.addAffiliateParamToUrl.bind(this)
    }

    componentDidMount(){
        this.QrpLoad();
    }

    openLiveChat (){
        var CSLive = global.open(
            'about:blank',
            '_blank',
            'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=500, height=500'
        );
        CSLive.document.title = 'Hỗ Trợ Trực Tuyến JBO';
        CSLive.focus();
        CSLive.location.href = 'https://acaiberryapp.hihi2u.com/acaiberryapp';
    }

    async QrpLoad() {
        let data = await fetchRequest(ApiPort.QrpLoad, 'GET', '', Apiversion);
        console.log(data);
        if(data.isSuccess){
            this.setState({
                mainSiteUrl : data.mainSiteUrl,
            })
        }
    }

    addAffiliateParamToUrl(url) {
        return url;
    }

    render(){
        let { mainSiteUrl } = this.state;
        return(
            <div className="hayhar-page restrict">
                <Header pathname={'restrict'} openLiveChat={this.openLiveChat} mainSiteUrl={mainSiteUrl} addAffiliateParamToUrl={this.addAffiliateParamToUrl}></Header>
                <div className="restrict-section-web">
                    <div className="IP-bg" > 
                        <div className="restrict-section-web-flex">
                           <div className="left">
                                <img  src="/static/images/restrict/guard_1.png" />
                           </div>
                            <div className="right">
                                <h2 className="p1">Dịch Vụ Không <br /> Thể Hỗ Trợ</h2>
                                <p className="p2">Xin lỗi, vị trí hiện tại của bạn không được hỗ trợ.</p>
                                <p className="p3">Chúng tôi tạm thời không thể cung cấp dịch vụ <br /> cho bạn. Chúng tôi xin lỗi vì sự bất tiện này!</p>
                                <p className="p4">Nếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ <br /> với Chăm Sóc Khách Hàng để được hỗ trợ.</p>

                                <div className="Btn">
                                    {/* <Button className="bt1" onClick={()=>{window.location.replace('/vn')}}>Làm Mới Trang</Button> */}
                                    <Button className="bt2" onClick={()=>{this.openLiveChat()}}>Chăm Sóc Khách Hàng</Button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div></div>
            </div>
        )
    }
}